/*
 * @Author: limingshuang limingshuang@yunhdkc.com
 * @Date: 2025-02-20 17:13:26
 * @LastEditors: limingshuang limingshuang@yunhdkc.com
 * @LastEditTime: 2025-04-27 14:25:47
 * @FilePath: \dyt_html_v2.0\src\store\modules\ask2.js
 * @Description: 在线问诊store
 */
import { getPatientList } from '@/apis/fromBaseApi/patient'
import {getAskOrderDetailApi} from '@/apis/ask2Api/order'
import Vue from 'vue'
let state = {
    // 就诊人列表
    patient_list: [],
    // 订单列表 key: groupId, value: orderInfo
    order_info_map: {},
    // guroupId和orderId 的映射
    groupId_orderId_map: {},
    // 群组号
    current_groupId: null,

}
const actions = {
    getPatientList({ commit }) {
        return new Promise((resolve, reject) => {
            getPatientList({current_page: 1,page_size: 15}).then(res => {
                commit('set_patient_list', res.data.list)
                resolve(res.data.list)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 通过groupId获取订单信息
    getOrderInfoByGroupId({ commit }, params) {
        const { groupId, OrderId } = params
        console.log('groupIdgroupIdgroupIdgroupIdgroupId',groupId);
        console.log('state.groupId_orderId_map',state.groupId_orderId_map);
        
        const orderId = state.groupId_orderId_map[groupId] || OrderId
        console.log('orderIdorderIdorderIdorderIdorderIdorderId',orderId);
        
        return new Promise((resolve, reject) => {
            getAskOrderDetailApi({ orderId }).then(res => {
                console.log('resresresresres',res);
                
                commit('set_order_info_map', { groupId, orderInfo: res.data })
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}
const mutations = {
    set_patient_list(state, data) {
        state.patient_list = data
    },
    set_order_info_map(state, { groupId, orderInfo }) {
        Vue.set(state.order_info_map, groupId, orderInfo);
        state.groupId_orderId_map[groupId] = orderInfo.id
    },
    set_current_groupId(state, groupId) {
        state.current_groupId = groupId
    },
}
const getters = {
    getPatientList(state) {
        return state.patient_list
    },
    getOrderInfoByGroupId: (state) => (groupId) => {
        return state.order_info_map[groupId]
    },
    getCurrentGroupId: (state) => (groupId) => {
        return state.current_groupId
    },
}
export default {
    state,
    mutations,
    actions,
    getters
  }
console.log(this);

// window.$store.dispatch('ask2/getPatientList')